"use client";

import { useTranslations } from "next-intl";
const ReviewsCountButton = ({
  totalElements
}) => {
  const t = useTranslations("Common");
  const scrollToSection = () => {
    const section = document.getElementById("reviewsSection");
    section?.scrollIntoView({
      behavior: "smooth"
    });
  };
  return <>
      {totalElements > 0 && <span className="text-productDetails-active cursor-pointer pt-0.5 text-base font-medium" onClick={scrollToSection}>{`${totalElements} ${t("ReviewsCount")}`}</span>}
    </>;
};
export default ReviewsCountButton;